module.exports = __webpack_public_path__ + "static/media/client-logo-vertical.6432ed6b.svg";